<script lang="ts">
  import "../../app.css";
  import {DetectedCountry, leftSidebarIsOpenStore} from "$lib/stores";
  import {onMount} from 'svelte';
  import {locale, translate} from "$lib/i18n";
  import TwitchIcon from "$lib/icons/TwitchIcon.svelte";
  import YoutubeIcon from "$lib/icons/YoutubeIcon.svelte";
  import FacebookIcon from "$lib/icons/FacebookIcon.svelte";
  import EmailIcon from "$lib/icons/EmailIcon.svelte";
  import Xicon from "$lib/icons/Xicon.svelte";
  import { geolocationService } from "$lib/services/geolocation.service";
  import { browser } from "$app/environment";
  import { get } from 'svelte/store';

  let leftSidebarIsOpen = true;
  let currentYear: number;
  export let data;
  export let hide: boolean = false;
  let detectedCountry = '';
  let countryDetectionInProgress = false;

  DetectedCountry.subscribe(value => {
    detectedCountry = value ?? '';
    console.log(detectedCountry);
  });

  leftSidebarIsOpenStore.subscribe(value => {
    leftSidebarIsOpen = value;
  });

  async function detectCountryClientSide() {
    if (!browser || countryDetectionInProgress) return;

    countryDetectionInProgress = true;

    try {
      try {
        const geoResponse = await fetch("https://ipapi.co/json/");
        const geoData = await geoResponse.json();

        if (geoData.country_code) {
          DetectedCountry.set(geoData.country_code);
          return;
        }
      } catch (error) {
        console.error("Error with ipapi.co:", error);
      }

      try {
        const geoResponse2 = await fetch("https://ipinfo.io/json");
        const geoData2 = await geoResponse2.json();

        if (geoData2.country) {
          DetectedCountry.set(geoData2.country);
          return;
        }
      } catch (error) {
        console.error("Error with ipinfo.io:", error);
      }

      try {
        const geoResponse3 = await fetch("https://geolocation-db.com/json/");
        const geoData3 = await geoResponse3.json();

        if (geoData3.country_code) {
          DetectedCountry.set(geoData3.country_code);
          return;
        }
      } catch (error) {
        console.error("Error with geolocation-db:", error);
      }

    } catch (error) {
      console.error("Error in client-side country detection:", error);
    } finally {
      countryDetectionInProgress = false;
    }
  }

  async function initializeCountryDetection() {
    await detectCountryClientSide();

    if (!get(DetectedCountry)) {
      try {
        const country = await geolocationService.detectCountry();
        if (country && country !== 'NL') {
          DetectedCountry.set(country);
        }
      } catch (error) {
        console.error("Error in geolocation service:", error);
      }
    }

    if (!get(DetectedCountry)) {
      DetectedCountry.set('UK');
    }
  }

  onMount(async () => {
    try {
      currentYear = new Date().getFullYear();
      await initializeCountryDetection();
      anj_ce4056a8_5516_45ee_b3e5_846851a62334.init();
    } catch (err) {
      console.error("Error in onMount:", err);
    }
  });
</script>

{#if !hide}
  <footer class="mt-28 bg-primary-blue w-full antialiased px-2">
    <div
            class="{leftSidebarIsOpen ? 'md:pl-60': 'md:pl-20'} container mx-auto xl:max-w-screen-2xl w-full py-12 lg:max-w-screen-xl md:max-w-screen-lg ">
      <div class="flex flex-wrap justify-between md:px-0 px-4">
        <div class="w-full md:w-1/5 mb-4 md:mb-0">
          <a href="{data.token ? (`/${$locale}/casino`) : `/${$locale}`}">
            <enhanced:img src="$lib/logo.svg?enhanced" width="100" alt="Forza.bet"/>
          </a>
          <div class="mt-4">
            <div class="flex space-x-4">
              <a href="https://x.com/FORZABETCASINO" target="_blank" class="text-gray-400 hover:text-white">
                <Xicon/>
              </a>
            </div>
          </div>
        </div>

        <div class="w-full md:w-1/5 mb-4 md:mb-0">
          <h3 class="text-white mb-2 text-base md:text-sm">{$translate('Support')}</h3>
          <ul class="space-y-2 md:space-y-1 text-sm md:text-xs">
            <li><a href="/{$locale}/faq" class="text-primary-lightBlue hover:text-white">F.A.Q</a></li>
            <li><a href="/{$locale}/kyc-policy"
                   class="text-primary-lightBlue hover:text-white">{$translate('KYC Policy/Procedures')}</a></li>
            <li><a href="/{$locale}/aml-policy"
                   class="text-primary-lightBlue hover:text-white">{$translate('AML Policy')}</a></li>
            <li><a href="/{$locale}/terms-and-conditions"
                   class="text-primary-lightBlue hover:text-white">{$translate('Terms and Conditions')}</a></li>
          </ul>
        </div>

        <div class="w-full md:w-1/5 mb-4 md:mb-0">
          <h3 class="text-white mb-2 text-base md:text-sm">{$translate('Programs and VIP')}</h3>
          <ul class="space-y-2 md:space-y-1 text-sm md:text-xs">
            <li><a href="https://affiliates.forza.bet" target="_blank"
                   class="text-primary-lightBlue hover:text-white">{$translate('Affiliate Program')}</a></li>
            <li><a href="/{$locale}/level-up"
                   class="text-primary-lightBlue hover:text-white">{$translate('Loyalty Program')}</a></li>
          </ul>
        </div>

        <div class="w-full md:w-1/5 mb-4 md:mb-0">
          <h3 class="text-white mb-2 text-base md:text-sm">{$translate('Responsible Gambling')}</h3>
          <ul class="space-y-2 md:space-y-1 text-sm md:text-xs">
            <li><a href="/{$locale}/provably-fair"
                   class="text-primary-lightBlue hover:text-white">{$translate('Provably Fair')}</a></li>
            <li><a href="/{$locale}/responsible-gambling"
                   class="text-primary-lightBlue hover:text-white">{$translate('Responsible Gambling')}</a></li>
          </ul>
        </div>

        <div class="w-full md:w-1/5 mb-4 md:mb-0">
          <h3 class="text-white mb-2 text-base md:text-sm">{$translate('Need Help?')}</h3>
          <div class="space-y-1 text-sm md:text-xs">
            <span class="text-primary-lightBlue">{$translate('Email us')}</span>
            <a href="mailto:support@forza.bet" class="text-gray-400 hover:text-white flex items-center">
              <EmailIcon css="mr-1.5 w-5 h-5"/>
              support@forza.bet</a>
          </div>
        </div>
      </div>

      <div class="mt-8 pt-8 border-t border-gray-800 flex flex-wrap md:justify-between items-center pb-12 md:pb-0">
        <div class="w-full md:w-auto mb-4 md:mb-0 text-center">
          <p class="text-gray-400 text-sm">&copy;{currentYear} ForzaBet {$translate('- All Rights Reserved.')}</p>
        </div>
        <div class="w-full md:w-auto flex items-center justify-center">
          {#if detectedCountry === 'PL' || detectedCountry === 'FI'}
            <div id="anj-ce4056a8-5516-45ee-b3e5-846851a62334" data-anj-seal-id="ce4056a8-5516-45ee-b3e5-846851a62334"
                 data-anj-image-size="32" data-anj-image-type="basic-small"></div>
          {:else}
            <div></div>
          {/if}
        </div>
      </div>
      {#if detectedCountry === 'GB' || detectedCountry === 'FR'  || detectedCountry === 'US'}
        <div></div>
      {:else}
        <div class="w-1/2 text-primary-lightBlue mt-2 text-xs">
          Forza.Bet is operated by NovaAxis Holdings International Ltd., with registered office address at 1st Floor,
          Columbus Centre, PO Box 2283, Road Town, Tortola VG 1110, BVI, a company incorporated under the laws of
          British Virgin Islands with company registration number 2149214 and is licensed by the Anjouan Gaming Board to
          offer games of chance under license number ALSI-152406053-FI4 in accordance with the Betting and Gaming act of
          2005 of Anjouan.
        </div>
      {/if}
    </div>
  </footer>
{/if}
